/**
 * @Author: wence@baidu.com
 * @Date: 2023-01-10 17:48:54
 * @LastEditors: v_huangyongxing@baidu.com
 * @LastEditTime: 2023-06-09 16:39:33
 * @FilePath: /m-anquan-baidu-com/src/containers/product/page_imagerecognition.js
 * @Description: 深度检测
 */
import React, {PureComponent} from 'react';
import PropType from 'prop-types';
import cn from 'classnames';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ProductTitle from '../../components/ProductTitle';
import ProBanner from '../../components/ProBanner';
import {fetchChackAiImage} from '../../actions/productAction';
import exif from 'exif-js';
import {bAntiBotSend} from '../../util';
import DrawRegion from './components/drawRegion';

import './page_imagerecognition.less';

class PageImageRecignition extends PureComponent {
    static propTypes = {
        bannerInfo: PropType.object,
        fetchChackAiImage: PropType.func,
        checkAiImageData: PropType.object
    }

    constructor(props) {
        super(props);

        this.state = {
            errorMsg: '',
            resultList: [],
            inputValue: '',
            isShowCanvas: false,
            isCheckLoading: false,
            isImageLoading: false
        };
    }

    componentDidMount() {
        const width = this.checkImageContainer.offsetWidth;
        const height = this.checkImageContainer.offsetHeight;
        this.draw = new DrawRegion({
            id: 'check-img',
            width,
            height
        });
    }

    addData(params, isFromdata) {
        let localData = {};
        try {
            bAntiBotSend();
            if (window.localStorage) {
                let localKey = '__abbaidu_20181211_cb';
                localData = JSON.parse(window.localStorage.getItem(localKey));
            }
        }
        catch (e) {
            localData = {};
        }

        if (isFromdata) {
            if (localData && localData.data) {
                params.append('data', localData.data);
            }
            if (localData && localData.key_id) {
                params.append('key_id', localData.key_id);
            }
            if (localData && localData.sign) {
                params.append('sign', localData.sign);
            }
        }
        else {
            if (localData && localData.data) {
                params.data = localData.data;
            }
            if (localData && localData.key_id) {
                params['key_id'] = localData.key_id;
            }
            if (localData && localData.sign) {
                params.sign = localData.sign;
            }
        }
    }

    fetchChackAiImage = (url, file, filename) => {
        this.setState({isCheckLoading: true});

        this.draw.drawImage({url}, async () => {
            let body = {};

            if (file) {
                body = new FormData();
                body.append('file', file, filename);
                this.addData(body, true);
            }
            else {
                body = {'upload_url': url};
                this.addData(body);
            }
            await this.props.fetchChackAiImage(body);

            const checkAiImageData = this.props.checkAiImageData || {};

            if (checkAiImageData.status === 0) {
                if (checkAiImageData.data && checkAiImageData.data.err_code === 0) {
                    const faceListLen = (checkAiImageData.data.face_list || []).length;
                    const curList = checkAiImageData.data.face_list.map((item, index) => {
                        return ({
                            location: item.location,
                            score: item.score,
                            textColor: item.score > 0.5 ? '#40C87F' : '#F5535B',
                            strokeStyle: item.score > 0.5 ? '#40C87F' : '#F5535B',
                            text: faceListLen === 1 ? '' : index + 1,
                            lineWidth: this.draw.getPixelRatio(2)
                        });
                    });

                    this.setState({resultList: curList, errorMsg: ''});
                    this.draw.drawStrokeInImage({list: curList});
                }
                else {
                    this.setState({errorMsg: checkAiImageData.data && checkAiImageData.data.err_msg});
                }
            }
            else {
                this.setState({errorMsg: checkAiImageData.description});
            }

            this.setState({isCheckLoading: false});
        }, () => {
            this.setState({errorMsg: '图片加载失败', isCheckLoading: false});
        });
    }

    onUploadFile = e => {
        const curfile = e.target.files[0];
        if (!curfile) {
            return;
        }
        this.draw.clearDraw();
        this.setState({isImageLoading: true, isShowCanvas: true, errorMsg: '', resultList: []});
        this.getRealImage(curfile).then(([blob, file]) => {
            this.setState({isImageLoading: false});
            if (!(file.type === 'image/png' || file.type === 'image/bmp' || file.type === 'image/jpeg')) {
                this.setState({errorMsg: '图片格式不正确，请重新上传'});
                return;
            }

            if (file.size > 1024 * 1024 * 5) {
                this.setState({errorMsg: '图片超大，请上传小于5M的图片'});
                return;
            }

            const readerFile = new FileReader();
            readerFile.readAsDataURL(file);
            readerFile.onload = e => {
                this.fetchChackAiImage(e.target.result, blob, file.name);
            };
            readerFile.onerror = function () {
                this.setState({errorMsg: '上传图片失败，请重新上传'});
            };
        }, () => {
            this.setState({isImageLoading: false});
        });
    }

    readFile(file) {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();

            fileReader.addEventListener('load', resolve);
            fileReader.addEventListener('error', reject);
            fileReader.readAsDataURL(file);
        });
    }

    compressImage(base64Data, orientation, quality, scale = 1) {
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.addEventListener('load', () => {
                const width = image.width * scale;
                const height = image.height * scale;
                const cvs = document.createElement('canvas');

                const context = cvs.getContext('2d');
                cvs.height = height;
                cvs.width = width;

                if (orientation && orientation !== 1) {
                    switch (orientation) {
                        case 6: // 旋转90度
                            cvs.height = width;
                            cvs.width = height;
                            context.rotate(Math.PI / 2);
                            context.drawImage(image, 0, -height, width, height);
                            break;
                        case 3: // 旋转180度
                            context.rotate(Math.PI);
                            context.drawImage(image, -width, -height, width, height);
                            break;
                        case 8: // 旋转-90度
                            cvs.height = width;
                            cvs.width = height;
                            context.rotate(3 * Math.PI / 2);
                            context.drawImage(image, -width, 0, width, height);
                            break;
                    }
                }
                else {
                    context.drawImage(image, 0, 0, width, height);
                }
                const dataURL = cvs.toDataURL('image/jpeg', quality);

                resolve(dataURL);
            });

            image.addEventListener('error', reject);
            image.src = base64Data;
        });
    }

    dataURLtoFile(base64Data, filename) {
        const arr = base64Data.split(',');
        // const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = window.atob(arr[1]);
        let len = bstr.length;
        const u8arr = new window.Uint8Array(len);
        while (len--) {
            u8arr[len] = bstr.charCodeAt(len);
        }
        const options = {type: 'image/jpeg'};
        const blob = new Blob([u8arr], options);
        return [blob, new File([u8arr], filename, options)];
    }

    getOriention(file) {
        return new Promise(resolve => {
            exif.getData(file, function () {
                resolve(exif.getTag(this, 'Orientation'));
            });
        });
    }

    getRealImage = async file => {
        if (!(file.type === 'image/png' || file.type === 'image/bmp' || file.type === 'image/jpeg')) {
            this.setState({errorMsg: '图片格式不正确，请重新上传', isImageLoading: false});
            return;
        }
        const fileSize = 1024 * 1024 * 2;
        const scale = (fileSize / file.size) > 1 ? 1 : (fileSize / file.size);
        const orientation = await this.getOriention(file);
        const data = await this.readFile(file);
        const fdate = await this.compressImage(data.target.result, orientation, scale, scale);

        const files = this.dataURLtoFile(fdate, file.name);

        return files;
    }

    onChange = e => {
        this.setState({inputValue: e.target.value});
    }

    onUpload = e => {
        e.stopPropagation();
        e.preventDefault();

        this.draw.clearDraw();
        this.setState({isShowCanvas: true});
        if (!/^(http|https):\/\//.test(this.state.inputValue)) {
            this.setState({errorMsg: '图片url无效，请更换图片后重新体验'});
            return;
        }

        this.fetchChackAiImage(this.state.inputValue);
        this.setState({errorMsg: '', inputValue: ''});
    }

    getNumber(number) {
        const n = number * 100;
        const newNum = n.toFixed(2);
        if (/^[0-9]+.00$/.test(newNum)) {
            return +newNum.split('.')[0];
        }

        if (/^[0-9]+.[0-9]{1}0$/.test(newNum)) {
            return +newNum.slice(0, 3);
        }

        return +newNum;
    }

    onFocus = () => {
        const navBar = document.querySelector('.nav-bar');

        if (navBar) {
            navBar.style.position = 'absolute';
        }
    }

    onBlur = () => {
        const navBar = document.querySelector('.nav-bar');

        if (navBar) {
            navBar.style.position = 'fixed';
        }
    }

    render() {
        const bannerInfo = this.props.bannerInfo || {};
        const productList = [
            {
                'mobile_pic': require('../../asset/image/page_imagerecognition/pic-1.png'),
                title: '人脸深度伪造检测',
                content: '识别图片或视频中的人脸是否存在伪造的情况，提供Deepfake、人脸融合这两种主要的人脸深度伪造检测'
            },
            {
                'mobile_pic': require('../../asset/image/page_imagerecognition/pic-2.png'),
                title: '人声伪造检测 (即将上线）',
                content: '识别声音是否存在伪造的情况，提供合成语音及人声转换检测'
            }
        ];
        const senceList = [
            {
                'mobile_pic': require('../../asset/image/page_imagerecognition/sence1.png'),
                title: '视频网站',
                content: '通过对视频中提取图片的检测，高效识别人脸伪造信息，降低人力审核成本‘降低业务违规风险'
            },
            {
                'mobile_pic': require('../../asset/image/page_imagerecognition/sence2.png'),
                title: '新闻机构',
                content: '识别机构网站或者资源库中的图片和视频是否存在人脸伪造信息，降低人力审核成本，降低业务违规风险。支持定期检测，也可对上传图片做实时检测'
            },
            {
                'mobile_pic': require('../../asset/image/page_imagerecognition/sence3.png'),
                title: '网络论坛',
                content: '识别网络论坛或者资源库中的图片和视频是否存在人脸伪造信息，降低人力审核成本，降低业务违规风险。支持定期检测，也可对上传图片做实时检测'
            },
            {
                'mobile_pic': require('../../asset/image/page_imagerecognition/sence4.png'),
                title: '新媒体',
                content: '识别新媒体或者资源库中的图片和视频是否存在人脸伪造信息，降低人力审核成本，降低业务违规风险。支持定期检测，也可对上传图片做实时检测'
            }
        ];

        const proinfoBox = [
            {
                'mobile_pic': require('../../asset/image/page_imagerecognition/icon_1.svg'),
                title: '持续领先的检测技术',
                content: '深度换脸伪造技术进步日新月异，持续的投入的对抗和检测，积累起海量数据，保障可靠的检测能力'
            },
            {
                'mobile_pic': require('../../asset/image/page_imagerecognition/icon_2.svg'),
                title: '识别准确率高',
                content: '假脸识别功能基于深度学习的智能识别技术，拥有海量人脸、图片训练集，准确率行业领先'
            },
            {
                'mobile_pic': require('../../asset/image/page_imagerecognition/icon_3.svg'),
                title: '不断维护的数据支撑',
                content: '深度换脸伪造技术进步日新月异，持续的投入的对抗和检测，积累起海量数据，保障可靠的检测能力'
            },
            {
                'mobile_pic': require('../../asset/image/page_imagerecognition/icon_4.svg'),
                title: '灵活的接入方式',
                content: '支持快速方便的WEB API或SDK调用，提供根据业务场景和需求适配的行业解决方案'
            }
        ];
        return (
            <div className="product">
                <div className="pro-banner-box bg-new">
                    <ProBanner
                        title={bannerInfo.title}
                        urlText={bannerInfo.urlText}
                        bgImg={bannerInfo.bgImg}
                        url={bannerInfo.url}
                    />
                    {bannerInfo.nextText ? (
                        <a href={bannerInfo.nextUrl} target="_blank" className="compliance-btn">
                            {bannerInfo.nextText}
                        </a>
                    ) : null}
                </div>

                <div className={'product-des'}>
                    凭借在深度伪造检测上深厚的技术积累，百度安全深度换脸检测平台在人脸伪造大数据中，
                    寻找造假的蛛丝马迹。通过训练深度神经网络模型识别假脸的边缘效应、纹理、肤色变化、分辨率差异、扭曲等特征来鉴别假脸，
                    结合数字图像处理技术，为数据鉴伪工作，提供有力支持。
                </div>

                <div className="product-mod">
                    <ProductTitle title="产品功能" />
                </div>

                <div className="product-mod">
                    {
                        productList.map((item, index) => {
                            return <div
                                key={index}
                                className="proinfo-box mui-flex"
                                style={{borderBottom: 0, paddingTop: 0, paddingBottom: '.8rem'}}>
                                <div className="proinfo-box-icon" style={{height: '1.8rem', width: '2.2rem'}}>
                                    <img
                                        src={item.mobile_pic}
                                        width={'100%'}
                                        alt={item.title}
                                    />
                                </div>
                                <div className="cell">
                                    <div
                                        className="proinfo-box-title"
                                        style={{marginBottom: '0.1rem'}}>
                                        {item.title}
                                    </div>
                                    <div className="proinfo-box-des">
                                        {item.content}
                                    </div>
                                </div>
                            </div>;
                        })
                    }
                </div>

                <div className="product-mod">
                    <ProductTitle title="功能体验" />
                </div>

                <div className="product-function">
                    <div className={cn('product-function-canvas', {show: this.state.isShowCanvas})}>
                        <div ref={checkImageContainer => {
                            this.checkImageContainer = checkImageContainer;
                        }} className="check-img-container">
                            {this.state.isImageLoading
                                && <div className="image-loading-cantainer">
                                    <div className="image-loading"></div>
                                </div>}
                            {this.state.isCheckLoading
                                && <div className="check-img-loading"></div>}
                            <canvas id="check-img" ref={checkImage => {
                                this.checkImage = checkImage;
                            }}></canvas>
                        </div>
                        {this.state.errorMsg
                            && <div className="product-function-canvas-tip">{this.state.errorMsg}</div>}
                        {!this.state.errorMsg
                            && this.state.resultList.length > 0
                            && <div className={cn(
                                'product-function-canvas-result',
                                {simple: this.state.resultList.length <= 3})}>
                                {this.state.resultList.map((item, index) => {
                                    const score = item.score;
                                    let isCur = score > 0.5;
                                    const curIndex = this.state.resultList.length === 1 ? '' : `${index + 1}.`;
                                    return (
                                        <div key={index}
                                            style={{color: isCur ? '#40C87F' : '#F5535B'}}
                                            className="product-function-canvas-result-item">
                                            {curIndex}{
                                                isCur ? '真脸' : '假脸'
                                            }{this.getNumber(isCur ? item.score : 1 - item.score)}%
                                        </div>
                                    );
                                })}
                            </div>}
                    </div>

                    <label className="product-function-upload">
                        <input type="file" accept="image/jpeg,image/png,image/bmp" onChange={this.onUploadFile} />
                        <div className="product-function-upload-des">上传检测图片</div>
                    </label>
                    <div className="product-function-blank">或</div>
                    <div className="product-function-url">
                        <form onSubmit={this.onUpload}>
                            <input
                                type="text"
                                onFocus={this.onFocus}
                                onBlur={this.onBlur}
                                value={this.state.inputValue}
                                onChange={this.onChange}
                                placeholder="请输入图片url" />
                        </form>
                    </div>
                    <div className="product-function-des">
                        仅支持PNG、JPG、JPEG、BMP类型文件，图片大小不超过5M
                    </div>
                </div>

                <div>
                    <div className="product-mod">
                        <ProductTitle title="适用场景" />
                    </div>
                    <div className={'product-mod'}>
                        {
                            senceList.map((item, index) => {
                                return <div
                                    className={'pro-applicable'}
                                    key={index}
                                    style={{backgroundImage: `url(${item.mobile_pic})`}}
                                >
                                    <div className={'pro-app-title'}>
                                        {item.title}
                                    </div>
                                    <div className={'pro-app-content'}>
                                        {item.content}
                                    </div>
                                </div>;
                            })
                        }
                    </div>
                </div>

                <div className="product-mod">
                    <ProductTitle title="产品特色" />
                </div>

                <div className={'product-mod'}>
                    {
                        proinfoBox.map((item, index) => {
                            const style = index === 3 ? {borderBottom: 0} : null;
                            return <div key={index} className="proinfo-box mui-flex" style={style}>
                                <div className={'proinfo-box-icon'}>
                                    <img
                                        src={item.mobile_pic}
                                        width={'100%'}
                                        alt={item.title}
                                    />
                                </div>
                                <div className={'cell'}>
                                    <div className={'proinfo-box-title'}>{item.title}</div>
                                    <div className={'proinfo-box-des'}>
                                        {item.content}
                                    </div>
                                </div>
                            </div>;
                        })
                    }
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({checkAiImageData: state.checkAiImageData}),
    dispatch => bindActionCreators({fetchChackAiImage}, dispatch)
)(PageImageRecignition);



// WEBPACK FOOTER //
// ./src/containers/product/page_imagerecognition.js